import React from "react";
import "./skeleton.css";

function Welcome() {
  return (
    <div className="section-wrap mt-5">
      <div className="h-5 w-[200px] animateSkl"></div>
      <div className="h-5 w-full mt-2 animateSkl"></div>
      <div className="h-16 w-full mt-8 animateSkl"></div>
      <div className="h-16 w-full mt-3 animateSkl"></div>
      <div className="h-16 w-full mt-3 animateSkl"></div>
    </div>
  );
}

export default Welcome;
